// extracted by mini-css-extract-plugin
export var csatScore = "_ku-5";
export var header = "_ku-1";
export var panelWrapper = "_ku-2";
export var postPreview = "_ku-3";
export var rightContent = "_ku-0";
export var wrappingText = "_ku-4";